var _defs, _circle, _circle2, _path, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crown_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 6.333,
    r: 1.5,
    className: "crown_svg__a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 6.417,
    r: 1.5,
    className: "crown_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22h16M4 19 1.953 7.828S3 13 7 13s5-7 5-7 1 7 5 7 5.047-5.093 5.047-5.093L20 19Z",
    className: "crown_svg__a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2,
    className: "crown_svg__a"
  })));
};
export { SvgCrown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnZpcC1jcm93bi1xdWVlbi0xPC90aXRsZT48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMiIgY3k9IjYuMzMzIiByPSIxLjUiLz48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMjIiIGN5PSI2LjQxNyIgcj0iMS41Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSI0IiB5MT0iMjIiIHgyPSIyMCIgeTI9IjIyIi8+PHBhdGggY2xhc3M9ImEiIGQ9Ik00LDE5LDEuOTUzLDcuODI4UzMsMTMsNywxM3M1LTcsNS03LDEsNyw1LDcsNS4wNDctNS4wOTMsNS4wNDctNS4wOTNMMjAsMTlaIi8+PGNpcmNsZSBjbGFzcz0iYSIgY3g9IjEyIiBjeT0iNCIgcj0iMiIvPjwvc3ZnPg==";